(() => {
  function removeDuplicateSizeGuides(root = document) {
    root.querySelectorAll('.product__info-container').forEach((info) => {
      const hasEarlyGuide = [...info.querySelectorAll('.one-life-purchase-assurance summary, .one-life-purchase-assurance button')]
        .some((el) => /size\s*(?:&|and)?\s*fit|size, fabric/i.test(el.textContent || ''));
      if (!hasEarlyGuide) return;
      const description = info.querySelector('.product__description');
      if (!description) return;
      [...description.querySelectorAll('h2, h3')].forEach((heading) => {
        if (!/size\s*(?:&|and)?\s*fit|size guide/i.test(heading.textContent || '')) return;
        let node = heading.nextElementSibling;
        while (node && !/^H[1-3]$/.test(node.tagName)) {
          const next = node.nextElementSibling;
          node.remove();
          node = next;
        }
        heading.remove();
      });
    });
  }

  function init(root = document) {
    root.querySelectorAll('media-gallery:not([data-model-switch-ready])').forEach((gallery) => {
      const slides = () => [...gallery.querySelectorAll('.product__media-item')];
      const thumbs = () => [...gallery.querySelectorAll('.thumbnail-list__item')];
      const inferModel = (item) => {
        const image = item.querySelector('img');
        const alt = (image?.alt || '').toLowerCase();
        const source = (image?.currentSrc || image?.src || '').toLowerCase().split('?')[0];
        const mediaText = alt + ' ' + source;
        if (/\b(women|woman|female|girls?)\b/.test(mediaText)) return 'women';
        if (/\b(men|man|male|boys?)\b/.test(mediaText)) return 'men';
        if (/flat[- ]lay|product[- ]view|close[- ]?up|detail|mockup|studio/.test(mediaText)) return 'all';
        if (/\blifestyle\b|\burban\b/.test(mediaText)) return 'men';
        if (/\bmodel\b/.test(mediaText)) return 'men';
        return 'all';
      };
      [...slides(), ...thumbs()].forEach((item) => {
        item.dataset.oneLifeModel = inferModel(item);
      });
      const productTitle = (gallery.closest('section')?.querySelector('.product__title')?.textContent || document.title).toLowerCase();
      const supportsModelViews = /set|shorts|joggers|sweatsuit/.test(productTitle);
      if (!supportsModelViews || !slides().length) return;
      gallery.dataset.modelSwitchReady = 'true';
      const controls = document.createElement('div');
      controls.className = 'one-life-model-switch';
      controls.setAttribute('role', 'group');
      controls.setAttribute('aria-label', 'Choose model photos');
      controls.innerHTML = '<button type="button" data-model="men" aria-pressed="true">Men</button><button type="button" data-model="women" aria-pressed="false">Women</button>';
      gallery.insertBefore(controls, gallery.querySelector('slider-component'));
      const modelAvailable = (model) => slides().some((slide) => slide.dataset.oneLifeModel === model || slide.dataset.oneLifeModel === 'all');
      controls.querySelectorAll('button[data-model]').forEach((button) => {
        const available = modelAvailable(button.dataset.model);
        button.disabled = !available;
        button.setAttribute('aria-disabled', String(!available));
        if (!available) button.setAttribute('title', 'No matching model photos are available for this view yet.');
      });
      let activeModel = 'men';
      const colorOption = () => variantControls?.querySelector('[data-option-name="Color"]:checked, select[data-option-name="Color"]');
      const selectedColor = () => (colorOption()?.value || '').trim().toLowerCase();
      const colorMatches = (item) => {
        const color = selectedColor();
        if (!color) return true;
        const alt = (item.querySelector('img')?.alt || '').toLowerCase();
        const hasColorLabel = /\b(black|white|red|blue|green|yellow|orange|purple|pink|brown|gray|grey|navy|beige|tan)\b/.test(alt);
        return !hasColorLabel || alt.includes(color);
      };
      const show = (model) => {
        activeModel = model;
        if (!modelAvailable(model)) return;
        slides().forEach((slide) => {
          const modelMatches = slide.dataset.oneLifeModel === model || slide.dataset.oneLifeModel === 'all';
          slide.classList.toggle('one-life-model-hidden', !modelMatches || !colorMatches(slide));
        });
        thumbs().forEach((thumb) => {
          const modelMatches = thumb.dataset.oneLifeModel === model || thumb.dataset.oneLifeModel === 'all';
          thumb.classList.toggle('one-life-model-hidden', !modelMatches || !colorMatches(thumb));
        });
        controls.querySelectorAll('button').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.model === model)));
        const modelSpecific = slides().find((slide) => slide.dataset.oneLifeModel === model && colorMatches(slide));
        const shared = slides().find((slide) => slide.dataset.oneLifeModel === 'all' && colorMatches(slide));
        const first = modelSpecific || shared || slides().find((slide) => (slide.dataset.oneLifeModel === model || slide.dataset.oneLifeModel === 'all') && colorMatches(slide))
          || slides().find((slide) => slide.dataset.oneLifeModel === model || slide.dataset.oneLifeModel === 'all');
        if (first) {
          const mediaId = first.dataset.mediaId;
          const thumbnail = thumbs().find((item) => item.dataset.target === mediaId);
          const thumbnailButton = thumbnail?.querySelector('button.thumbnail');
          if (thumbnailButton) {
            thumbnailButton.click();
          } else {
            const scroller = gallery.querySelector('.product__media-list');
            scroller?.scrollTo({ left: first.offsetLeft, behavior: 'smooth' });
          }
        }
      };
      const variantControls = gallery.closest('section')?.querySelector('variant-selects, variant-radios') || document.querySelector('variant-selects, variant-radios');
      controls.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-model]');
        if (!button) return;
        const target = button.dataset.model;
        const genderOption = [...(variantControls?.querySelectorAll('[data-option-name="Gender"]') || [])].find((option) => {
          const value = (option.value || '').toLowerCase();
          return target === 'women' ? /women|female/.test(value) : /men|male/.test(value);
        });
        if (genderOption && !genderOption.checked) genderOption.click();
        else show(target);
      });
      const initialGender = variantControls?.querySelector('[data-option-name="Gender"]:checked')?.value?.toLowerCase();
      const preferredModel = /female|women/.test(initialGender || '') ? 'women' : 'men';
      show(modelAvailable(preferredModel) ? preferredModel : (modelAvailable('men') ? 'men' : 'women'));
    });
    removeDuplicateSizeGuides(root);
  }

  document.addEventListener('change', (event) => {
    const option = event.target;
    if (!option || (option.dataset?.optionName || '').toLowerCase() !== 'gender') return;
    const target = (option.value || '').toLowerCase() === 'female' ? 'women' : 'men';
    const section = option.closest('section');
    const gallery = section?.querySelector('media-gallery[data-model-switch-ready]') || document.querySelector('media-gallery[data-model-switch-ready]');
    const button = gallery?.querySelector('.one-life-model-switch button[data-model="' + target + '"]');
    if (button && button.getAttribute('aria-pressed') !== 'true') button.click();
  }, true);

  document.addEventListener('change', (event) => {
    const optionName = (event.target?.dataset?.optionName || '').toLowerCase();
    if (optionName !== 'color') return;
    const gallery = event.target.closest('section')?.querySelector('media-gallery[data-model-switch-ready]') || document.querySelector('media-gallery[data-model-switch-ready]');
    if (!gallery) return;
    const womenButton = gallery.querySelector('.one-life-model-switch button[data-model="women"]');
    const menButton = gallery.querySelector('.one-life-model-switch button[data-model="men"]');
    window.setTimeout(() => (womenButton?.getAttribute('aria-pressed') === 'true' ? womenButton : menButton)?.click(), 50);
  }, true);

  function initEmailPopup() {
    if (document.getElementById('one-life-email-popup')) return;
    const headingSource = document.querySelector('.footer-block__newsletter .footer-block__heading');
    const sourceForm = document.querySelector('#ContactFooter');
    if (!headingSource || !sourceForm) return;
    const storageKey = 'oneLifeEmailPopupLastShown';
    const week = 7 * 24 * 60 * 60 * 1000;
    try {
      if (Date.now() - Number(localStorage.getItem(storageKey) || 0) < week) return;
    } catch (_) {}

    const rawHeading = (headingSource.textContent || '').replace(/\\s+/g, ' ').trim();
    const parts = rawHeading.split('—');
    const titleText = (parts[0] || rawHeading).trim();
    const bodyText = (parts.slice(1).join('—') || '').trim();
    const dialog = document.createElement('dialog');
    dialog.id = 'one-life-email-popup';
    dialog.setAttribute('aria-labelledby', 'one-life-email-popup-title');
    dialog.setAttribute('aria-describedby', 'one-life-email-popup-copy');
    dialog.innerHTML = '<style>' +
      '#one-life-email-popup{width:min(560px,calc(100% - 32px));max-width:none;max-height:calc(100% - 32px);padding:0;border:1px solid #bfa66e;border-radius:0;background:#101010;color:#f3efe6;box-shadow:0 24px 80px rgba(0,0,0,.55)}' +
      '#one-life-email-popup::backdrop{background:rgba(0,0,0,.72)}' +
      '#one-life-email-popup .ol-popup-inner{position:relative;padding:clamp(30px,7vw,58px);text-align:center}' +
      '#one-life-email-popup h2{margin:0 auto 16px;max-width:420px;color:#f3efe6;font-size:clamp(28px,5vw,42px);line-height:1.08;letter-spacing:.02em}' +
      '#one-life-email-popup p{margin:0 auto 28px;max-width:400px;color:#d4c8a9;font-size:15px;line-height:1.55}' +
      '#one-life-email-popup .ol-popup-close{position:absolute;top:12px;right:12px;width:42px;height:42px;border:1px solid #8b7952;background:transparent;color:#f3efe6;font:28px/1 Arial,sans-serif;cursor:pointer}' +
      '#one-life-email-popup .ol-popup-close:hover{background:#28251e}' +
      '#one-life-email-popup .footer__newsletter{max-width:420px;margin:0 auto}' +
      '#one-life-email-popup .footer-block__heading{display:none}' +
      '#one-life-email-popup .newsletter-form__field-wrapper{width:100%}' +
      '#one-life-email-popup .field__input{background:#171717;color:#fff;border:1px solid #8b7952;min-height:54px}' +
      '#one-life-email-popup .newsletter-form__button{background:#d7ba7b;color:#101010;min-height:54px}' +
      '#one-life-email-popup .field__label{color:#d4c8a9}' +
      '@media(max-width:480px){#one-life-email-popup{width:calc(100% - 24px)}#one-life-email-popup .ol-popup-inner{padding:50px 24px 28px}}' +
      '</style>';
    const inner = document.createElement('div');
    inner.className = 'ol-popup-inner';
    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'ol-popup-close';
    close.textContent = '×';
    const searchClose = document.querySelector('.search-modal__close-button');
    close.setAttribute('aria-label', searchClose?.getAttribute('aria-label') || 'Close');
    const title = document.createElement('h2');
    title.id = 'one-life-email-popup-title';
    title.textContent = titleText;
    const copy = document.createElement('p');
    copy.id = 'one-life-email-popup-copy';
    copy.textContent = bodyText;
    const form = sourceForm.cloneNode(true);
    form.id = 'OneLifePopupForm';
    form.action = '/contact#OneLifePopupForm';
    form.querySelectorAll('[id]').forEach((el) => {
      if (el.id === 'ContactFooter') return;
      el.id = el.id.replace('sections--27986701779114__footer', 'OneLifePopup').replace('NewsletterForm--', 'NewsletterForm--');
    });
    const email = form.querySelector('input[type="email"]');
    const label = form.querySelector('label[for]');
    const submit = form.querySelector('button[type="submit"]');
    if (email) {
      email.id = 'NewsletterForm--OneLifePopup';
      email.autocomplete = 'email';
    }
    if (label && email) label.htmlFor = email.id;
    if (submit) {
      submit.id = 'Subscribe--OneLifePopup';
      submit.setAttribute('aria-label', submit.getAttribute('aria-label') || 'Subscribe');
    }
    const formType = form.querySelector('input[name="form_type"]');
    const utf8 = form.querySelector('input[name="utf8"]');
    const tags = form.querySelector('input[name="contact[tags]"]');
    if (formType) formType.value = 'customer';
    if (utf8) utf8.value = '✓';
    if (tags) tags.value = 'newsletter';
    inner.append(close, title, copy, form);
    dialog.append(inner);
    document.body.append(dialog);

    let previousFocus = null;
    const markSeen = () => {
      try { localStorage.setItem(storageKey, String(Date.now())); } catch (_) {}
    };
    const show = () => {
      if (dialog.open) return;
      previousFocus = document.activeElement;
      markSeen();
      dialog.showModal();
      email?.focus();

      window.removeEventListener('scroll', onScroll);
    };
    const onScroll = () => {
      const maxScroll = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      if (window.scrollY / maxScroll >= 0.65) show();
    };

    window.addEventListener('scroll', onScroll, {passive:true});
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', () => {

      window.removeEventListener('scroll', onScroll);
      previousFocus?.focus?.();
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    init();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (payload) => {
        const sectionId = payload?.data?.sectionId;
        const productInfo = sectionId
          ? document.querySelector('product-info[data-section="' + sectionId + '"]')
          : document.querySelector('product-info');
        const gallery = productInfo?.querySelector('media-gallery[data-model-switch-ready]');
        const button = gallery?.querySelector('.one-life-model-switch button[data-model="' + (/female|women/i.test(productInfo?.querySelector('[data-option-name="Gender"]:checked')?.value || '') ? 'women' : 'men') + '"]');
        if (button) button.click();
      });
    }
  });
  document.addEventListener('shopify:section:load', (event) => { init(event.target); initEmailPopup(); });
  document.addEventListener('DOMContentLoaded', () => initEmailPopup());
})();
